"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const ModelsPanelButton_1 = __importDefault(require("../../molecules/ModelsPanelButton"));
const device_1 = require("@completeanatomy/device");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const models_1 = require("@completeanatomy/models");
function ModelsPanelContent({ className, models, onSelectModel, selectedTab, }) {
    const maleModels = (0, models_1.useMaleModels)();
    const [tabModels, setTabModels] = (0, react_1.useState)(maleModels);
    const language = (0, device_1.useLanguage)();
    (0, react_1.useEffect)(() => {
        switch (selectedTab) {
            case bridge_schema_1.ModelsPanelTabType.Male:
                setTabModels(models.filter(model => model.type === bridge_schema_1.ModelType.Male));
                return;
            case bridge_schema_1.ModelsPanelTabType.Female:
                setTabModels(models.filter(model => model.type === bridge_schema_1.ModelType.Female));
                return;
            case bridge_schema_1.ModelsPanelTabType.Detailed:
                if (language == 'zh') {
                    setTabModels(models
                        .filter(model => !!model.isDetailed === true)
                        .sort((a, b) => a.name.localeCompare(b.name, 'zh-CN')));
                }
                else {
                    setTabModels(models
                        .filter(model => !!model.isDetailed === true)
                        .sort((a, b) => a.name.localeCompare(b.name)));
                }
                return;
            case bridge_schema_1.ModelsPanelTabType.Pinned:
                setTabModels(models.filter(model => model.isPinned === true));
                return;
            default:
                return;
        }
    }, [language, models, selectedTab]);
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'ModelsPanelContent_Container', children: tabModels &&
            tabModels.map((model, index) => {
                return ((0, jsx_runtime_1.jsx)(ModelsPanelButton_1.default, { model: model, access: model.access, onClick: onSelectModel, "data-e2e": 'ModelsPanelContent_ModelsPanelButton' }, index));
            }) }));
}
exports.default = ModelsPanelContent;
const Container = (0, styled_components_1.default)(ui_1.SimpleScrollView) `
  display: grid;
  grid-gap: 8px;
  grid-template-rows: repeat(auto-fill, 160px);
  grid-template-columns: repeat(auto-fill, 160px);
  justify-content: center;

  max-height: calc(100% - 164px);
  padding: 16px 16px;

  @media screen and (min-width: 768px) {
    padding: 16px 32px;
  }

  ${ui_1.device.laptop((0, styled_components_1.css) `
    grid-gap: 16px;
  `)};
`;
